import { render, staticRenderFns } from "./EmailUpdate.vue?vue&type=template&id=48b2f3b2"
import script from "./EmailUpdate.vue?vue&type=script&lang=js"
export * from "./EmailUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports